import React from 'react'
import I18n from 'i18n'
import Field from '../common/Field'

export default class ActiefTransport extends React.Component {
  render () {
    const values = this.props.data.values
    return (
      <>
        <div className='sport-fields'>
          <Field
            title={I18n.t('questionnaires.actief_transport.v1')}
            value={values.v1}
          />

          {values.v2 && (
            <Field
              title={I18n.t('questionnaires.actief_transport.v2')}
              value={Array.isArray(values.v2) ? values.v2.join(', ') : values.v2}
            />
          )}

          {values.v3 && (
            <Field
              title={I18n.t('questionnaires.actief_transport.v3')}
              value={Array.isArray(values.v3) ? values.v3.join(', ') : values.v3}
            />
          )}

          {values.v4 && (
            <Field
              title={I18n.t('questionnaires.actief_transport.v4')}
              value={Array.isArray(values.v4) ? values.v4.join(', ') : values.v4}
            />
          )}

          {values.v5 && (
            <Field
              title={I18n.t('questionnaires.actief_transport.v5')}
              value={values.v5}
            />
          )}

          {values.v6 && (
            <Field
              title={I18n.t('questionnaires.actief_transport.v6')}
              value={Array.isArray(values.v6) ? values.v6.join(', ') : values.v6}
            />
          )}

          <Field
            title={I18n.t('questionnaires.actief_transport.v7')}
            value={values.v7}
          />

          {values.v8 && (
            <Field
              title={I18n.t('questionnaires.actief_transport.v8')}
              value={values.v8}
            />
          )}

          {values.v9 && (
            <Field
              title={I18n.t('questionnaires.actief_transport.v9')}
              value={values.v9}
            />
          )}

          <Field
            title={I18n.t('questionnaires.actief_transport.v10')}
            value={values.v10}
          />

          {values.v11 && (
            <Field
              title={I18n.t('questionnaires.actief_transport.v11')}
              value={Array.isArray(values.v11) ? values.v11.join(', ') : values.v11}
            />
          )}

          {values.v12 && (
            <Field
              title={I18n.t('questionnaires.actief_transport.v12')}
              value={Array.isArray(values.v12) ? values.v12.join(', ') : values.v12}
            />
          )}

          {values.v13 && (
            <Field
              title={I18n.t('questionnaires.actief_transport.v13')}
              value={values.v13}
            />
          )}

          {values.v14 && (
            <Field
              title={I18n.t('questionnaires.actief_transport.v14')}
              value={values.v14}
            />
          )}

          {values.v15 && (
            <Field
              title={I18n.t('questionnaires.actief_transport.v15')}
              value={Array.isArray(values.v15) ? values.v15.join(', ') : values.v15}
            />
          )}

          <Field
            title={I18n.t('questionnaires.actief_transport.v16')}
            value={values.v16}
          />

          <Field
            title={I18n.t('questionnaires.actief_transport.v17')}
            value={values.v17}
          />
        </div>
      </>
    )
  }
}
